'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { LOADING_MESSAGES } from '../../utils/loadingMessages';
import { AstronautArtwork } from '../common/AstronautArtwork';
import styles from '../common/AstronautArtwork.module.scss';
import Button from '../common/Button';
interface SplashProps {
  mode?: 'loading' | 'maintenance';
  onRetry?: () => void;
  // Set while the splash is being dismissed so it can play its fade-out
  // before Main unmounts it.
  exiting?: boolean;
}
const LoadingView = t0 => {
  const $ = _c(3);
  const {
    message
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="animate-splash-pulse"><Image src="/images/factiiiIcon.svg" alt="Factiii" width={80} height={80} className="rounded-2xl" priority={true} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== message) {
    t2 = <div className="flex flex-col items-center justify-center gap-6">{t1}<p key={message} className="anim-enter h-5 text-sm text-textSecondary opacity-70 [--enter-duration:400ms]">{message}</p></div>;
    $[1] = message;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const ArtworkView = t0 => {
  const $ = _c(20);
  const {
    title,
    subtitle,
    buttonText,
    onAction,
    leftDigit,
    rightDigit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      pointerEvents: "auto"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== subtitle) {
    t3 = <span className="text-base text-textSecondary">{subtitle}</span>;
    $[2] = subtitle;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3 || $[5] !== title) {
    t4 = <div>{title}{t2}{t3}</div>;
    $[4] = t3;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== buttonText || $[8] !== onAction) {
    t5 = <Button variant="TRANSPARENT" borderTransparent={false} onClick={onAction} text={buttonText} />;
    $[7] = buttonText;
    $[8] = onAction;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className={styles.center} style={t1}><div className={`${styles.sorry} text-textPrimary`}>{t4}{t5}</div></div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== leftDigit || $[14] !== rightDigit || $[15] !== t6) {
    t7 = <AstronautArtwork size={1.4} messages={LOADING_MESSAGES} leftDigit={leftDigit} rightDigit={rightDigit}>{t6}</AstronautArtwork>;
    $[13] = leftDigit;
    $[14] = rightDigit;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7 || $[18] !== title) {
    t8 = <div key={title} className="anim-enter flex h-full w-full flex-col items-center justify-center [--enter-duration:500ms]">{t7}</div>;
    $[17] = t7;
    $[18] = title;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export const Splash = t0 => {
  const $ = _c(14);
  const {
    mode: t1,
    onRetry,
    exiting: t2
  } = t0;
  const mode = t1 === undefined ? "loading" : t1;
  const exiting = t2 === undefined ? false : t2;
  const [message, setMessage] = useState("");
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      document.body.style.overflow = "hidden";
      const pickMessage = () => setMessage(LOADING_MESSAGES[Math.floor(Math.random() * LOADING_MESSAGES.length)]);
      pickMessage();
      const interval = setInterval(pickMessage, 3000);
      return () => {
        document.body.style.overflow = "";
        clearInterval(interval);
      };
    };
    t4 = [];
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  useEffect(t3, t4);
  const t5 = `fixed inset-0 z-splash flex flex-col items-center justify-center overflow-hidden bg-background-primary font-custom text-textPrimary [--exit-duration:500ms] ${exiting ? "anim-exit" : ""}`;
  let t6;
  if ($[2] !== message || $[3] !== mode) {
    t6 = mode === "loading" && <LoadingView message={message} />;
    $[2] = message;
    $[3] = mode;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== mode || $[6] !== onRetry) {
    t7 = mode === "maintenance" && <ArtworkView title="Service Unavailable." subtitle="We are currently undergoing maintenance." buttonText="Try again" onAction={onRetry || _temp} />;
    $[5] = mode;
    $[6] = onRetry;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t5 || $[12] !== t8) {
    t9 = <div data-testid="splash-screen" className={t5}>{t8}</div>;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
function _temp() {
  return window.location.reload();
}